<template>
  <main-layout>
    <v-layout wrap>
      <v-flex sm1 shrink class="text-xs-right">
        <v-btn v-if="!showAllMenu" color="primary" icon outline @click="setShowAllMenu"
          ><i class="fa fa-th" aria-hidden="true"></i
        ></v-btn>
      </v-flex>
      <v-flex sm11>
        <v-tabs
          v-if="!showAllMenu"
          v-model="currentView"
          color="white"
          :slider-color="$vuetify.theme.primary"
          show-arrows
        >
          <v-tab href="#FirstAnnouncement" ripple>{{ $t('First Announcement') }}</v-tab>
          <v-premium-lock style="margin-top: 5px; margin-left: -6px;" :inline="true">
          </v-premium-lock>
          <v-tab href="#WelcomeMessage" ripple>{{ $t('Welcome Message') }}</v-tab>
          <v-tab href="#Conversation" ripple>{{ $t('Conversation') }}</v-tab>
          <v-tab v-if="selectedBot.packages.includes('facebook')" href="#Comment" ripple>{{
            $t('Comment to Inbox')
          }}</v-tab>
          <v-tab v-if="selectedBot.pageid == '361231620965547'" href="#LiveAuction" ripple>{{
            $t('live_auction')
          }}</v-tab>
          <v-tab
            v-if="
              !selectedBot.pagerole || (selectedBot.pagerole && selectedBot.pagerole == 'admin')
            "
            href="#Training"
            ripple
            >{{ $t('Training') }}</v-tab
          >
          <v-premium-lock style="margin-top: 5px; margin-left: -6px;" :inline="true">
          </v-premium-lock>
          <v-tab href="#Calendar" v-if="selectedBot.selected_presets === '115'" ripple>{{
            $t('calendar_reservation')
          }}</v-tab>
        </v-tabs>
      </v-flex>
    </v-layout>
    <template>
      <component :is="currentView"></component>
    </template>
    <v-container v-if="showAllMenu">
      <h1 class="mb-3 mt-1">{{ $t('chatbot') }}</h1>
      <v-layout row wrap>
        <template v-for="(menu, i) in menuTab">
          <template v-if="menu.page.length === 0 || menu.page.includes(selectedBot.pageid)">
            <v-flex
              xs4
              sm3
              md2
              lg2
              style="padding: 2%"
              :key="i"
              v-if="menu.tab !== 'ProductAnalytics' || showProductAnalytic"
            >
              <v-hover
                style="cursor: pointer"
                v-if="menu.isPremiumLock.includes($store.getters.getPackage)"
              >
                <v-card
                  slot-scope="{ hover }"
                  @click="setTabMenu(menu.tab)"
                  :class="`elevation-${hover ? 12 : 2}`"
                  style="height: 100%"
                  class="text-xs-center"
                >
                  <v-img
                    aspect-ratio="1"
                    :src="`/static/img/assets/chatbot-menu/${menu.image}.png`"
                    class="white--text align-end"
                    :style="{
                      'background-color': !menu.image ? '#D9D9D9' : '#fff'
                    }"
                  >
                  </v-img>

                  <v-card-actions class="primary--text" style="justify-content: center">
                    <span>{{ menu.name }}</span>
                  </v-card-actions>
                </v-card>
              </v-hover>
              <div v-else>
                <v-card
                  :class="`elevation-${hover ? 12 : 2}`"
                  style="height: 100%"
                  class="text-xs-center"
                >
                  <v-img
                    style="opacity: 0.5"
                    aspect-ratio="1"
                    :src="`/static/img/assets/chatbot-menu/${menu.image}.png`"
                    class="white--text align-end"
                  >
                  </v-img>
                  <v-btn
                    v-if="!$vuetify.breakpoint.xs"
                    @click="setTabMenu(menu.tab)"
                    color="primary"
                    style="margin: auto; position: absolute; top: 10px; left: 15px"
                    >ดูตัวอย่าง
                  </v-btn>
                  <v-premium-lock></v-premium-lock>
                  <v-card-actions
                    class="primary--text"
                    style="justify-content: center; opacity: 0.5"
                  >
                    <span>{{ menu.name }}</span>
                  </v-card-actions>
                </v-card>
              </div>
            </v-flex>
          </template>
        </template>
      </v-layout>
    </v-container>
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import WelcomeMessage from '@/components/view/welcomemessage/WelcomeMessage'
import Conversation from '@/components/view/intent/Conversation'
import Calendar from '@/components/view/intent/calendar/Controller'
import Comment from '@/components/view/intent/CommentToInbox'
import Training from '@/components/view/intent/Training'
import LiveAuction from '@/components/view/liveAuction/Controller'
import FirstAnnouncement from '@/components/view/FirstAnnouncement'
export default {
  components: {
    WelcomeMessage,
    LiveAuction,
    Conversation,
    Comment,
    Training,
    Calendar,
    FirstAnnouncement
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  data: function() {
    return {
      currentView: null,
      showAllMenu: true,
      menuTab: [
        {
          name: this.$t('First Announcement'),
          tab: 'FirstAnnouncement',
          image: 'icon_chatbot_first_announcement',
          isPremiumLock: ['premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('Welcome Message'),
          tab: 'WelcomeMessage',
          image: 'icon_chatbot_welcome',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('Conversation'),
          tab: 'Conversation',
          image: 'icon_chatbot_conversation',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('Reply Comment'),
          tab: 'Comment',
          image: 'icon_chatbot_comment',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('Training'),
          tab: 'Training',
          image: 'icon_chatbot_training',
          isPremiumLock: ['premium', 'advanced'],
          page: []
        }
      ]
    }
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      vm.showAllMenu = false
      vm.currentView = vm.$route.query.tab
    }
  },
  methods: {
    setShowAllMenu() {
      if (this.$route.query.tab) {
        this.$router.push(this.$route.path).catch(() => {})
      }
      this.currentView = null
      this.showAllMenu = true
    },
    setTabMenu(name) {
      this.currentView = name
      this.showAllMenu = false
    },
    updateRoute: function() {
      try {
        this.$router
          .push({
            name: 'chatbot',
            path: '/chatbot',
            query: {
              tab: this.currentView
            }
          })
          .catch(() => {})
      } catch (error) {}
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function() {
      this.updateRoute()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/chatbot/main.vue